import { setTableColumnOrder, toggleTableColumn, toggleTablePin } from '../store/tablePrefs/tablePrefsSlice';
import { useAppDispatch, useAppSelector } from './storeHooks';

const NONE: string[] = [];

/** The columns an admin hid on a table, kept across sessions. */
const useHiddenColumns = (table: string) => {
  const dispatch = useAppDispatch();
  const hiddenColumns = useAppSelector((state) => state.tablePrefs.hiddenColumns[table] ?? NONE);
  const columnOrder = useAppSelector((state) => state.tablePrefs.columnOrder?.[table]);
  const pinnedColumns = useAppSelector((state) => state.tablePrefs.pinnedColumns?.[table] ?? NONE);
  return {
    hiddenColumns,
    onToggleColumn: (key: string) => dispatch(toggleTableColumn({ table, key })),
    columnOrder,
    onColumnOrderChange: (order: string[]) => dispatch(setTableColumnOrder({ table, order })),
    pinnedColumns,
    onTogglePin: (key: string) => dispatch(toggleTablePin({ table, key })),
  };
};

export default useHiddenColumns;
